import React from 'react';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyApiKeyManagement = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-api-key-management", jiraSpaEntry: "async-jira-eoc-api-key-management" */ '@atlassian/jira-eoc-api-key-management'
		),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyApiKeyManagement}
		pageId="async-jira-eoc-api-key-management"
		shouldShowSpinner={false}
	/>
);
